export class NumberFormatter {
  static price (num: number) {
    const formatter = new Intl.NumberFormat('ja-JP', { style: 'decimal' })

    return formatter.format(num) + '円'
  }

  static time (sec: number) {
    const hours = Math.floor(sec / 3600)
    const minutesSec = sec % 3600
    const minutes = Math.floor(minutesSec / 60)
    const seconds = minutesSec % 60

    return `${hours}時間${minutes}分${seconds}秒`
  }

  static creditCardNumber (num: string) {
    const chunks = this.toHankakuNumber(num).replace(/[^\d]/g, '').slice(0, 16).match(/.{1,4}/g)

    if (chunks) {
      return chunks.join('-')
    } else {
      return num
    }
  }

  static creditCardExpiration (date: string) {
    const hankaku = this.toHankakuNumber(date)
    const exp = hankaku.replace(/\/20(\d\d)/, '/$1').replace(/[^\d]/g, '').slice(0, 4)

    if (exp.length === 4) {
      return exp.match(/\d{2}/g)?.join('/')
    } else {
      return date
    }
  }

  static creditCardSecurityCode (date: string) {
    return this.toHankakuNumber(date).replace(/[^\d]/g, '').slice(0, 4)
  }

  static zipCode (num: string) {
    const code = this.toHankakuNumber(num).replace(/[^\d]/g, '').slice(0, 7)

    if (code) {
      return code.slice(0, 3) + '-' + code.slice(3, 7)
    } else {
      return ''
    }
  }

  static phoneNumber (num: string) {
    return this.toHankakuNumber(num).replace(/[^\d-]/g, '')
  }

  private static toHankakuNumber (num: string) {
    return num.replace(/[０-９]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xFEE0))
  }
}
